<template>
  <div>
    <div class="top-menu">
      <a-button class="btn-back" type="primary" @click="backReportAll">Back</a-button>
    </div>
    <a-table
      :scroll="{ x: 1300, y: 700 }"
      :columns="columnsMediaListTable"
      :data-source="MediaListSource"
      bordered
    >
      <template v-for="col in ['plan', 'komentarz']" :slot="col" slot-scope="text">
        <div :key="col">
          <template>{{ text }}</template>
        </div>
      </template>
      <template slot="project" slot-scope="text,record">
        <template>
          <a
            target="_blank"
            :href="'https://' + domain + '/crm/deal/details/' + record.id + '/' "
          >{{text}}</a>
        </template>
      </template>
      <template slot="kontrahent" slot-scope="text">
        <div>
          <template>{{searchCompany(text)}}</template>
        </div>
      </template>
      <template slot="typPrzychodu" slot-scope="text">
        <div>
          <template>{{ searchTypeArrival(text) }}</template>
        </div>
      </template>
      <template slot="platnik" slot-scope="text">
        <div>
          <template>{{ searchPlatnik(text) }}</template>
        </div>
      </template>
      <template slot="specjalista" slot-scope="text">
        <div>
          <template>{{ searchUser(text) }}</template>
        </div>
      </template>
      <template slot="opiekunCS" slot-scope="text">
        <div>
          <template>{{ searchUser(text) }}</template>
        </div>
      </template>
    </a-table>
  </div>
</template>

<script>
import { getMediaListForecastsSort, getMediaListSort } from "@/requestFunc";
import moment from "moment";

export default {
  name: "reportUserMonth",
  props: ["settings", "assigned", "selectGroup", "domain"],
  data() {
    return {
      MediaListSource: [],
      columnsMediaListTable: [
        {
          title: this.$t("Project"),
          dataIndex: "project",
          scopedSlots: { customRender: "project" },
          width: 100,
        },
        {
          title: "Kontrahent",
          dataIndex: "kontrahent",
          scopedSlots: { customRender: "kontrahent" },
          width: 160,
        },
        {
          title: "Typ przychodu",
          dataIndex: "typPrzychodu",
          scopedSlots: { customRender: "typPrzychodu" },
          width: 120,
        },
        {
          title: this.$t("Płatnik"),
          dataIndex: "platnik",
          scopedSlots: { customRender: "platnik" },
          width: 130,
        },
        {
          title: "Specjalista PPC",
          dataIndex: "specjalista",
          scopedSlots: { customRender: "specjalista" },
          width: 120,
        },
        {
          title: "Opiekun CS",
          dataIndex: "opiekunCS",
          scopedSlots: { customRender: "opiekunCS" },
          width: 120,
        },
        {
          title: "Plan",
          dataIndex: "plan",
          scopedSlots: { customRender: "plan" },
          width: 80,
        },
        {
          title: "Komentarz",
          dataIndex: "komentarz",
          scopedSlots: { customRender: "komentarz" },
          width: 110,
        },
      ],
      userList: [],
      companyList: [],
      platnikList: [],
      typPrzychoduList: [],
    };
  },
  computed: {
    selectKontrahentList: function () {
      return this.settings.company.map((company) => ({
        id: company.ID,
        name: company.TITLE,
      }));
    },
    selectSpecjalistaList: function () {
      return this.settings.data_user.map((user) => ({
        id: user.ID,
        name: user.LAST_NAME + " " + user.NAME,
      }));
    },
  },
  methods: {
    backReportAll: function () {
      this.$emit("userReport", false);
    },

    updateDataMediaList() {
      let sort = {};
      getMediaListSort(sort)
        .done((data) => {
          let item = data == "" ? {} : JSON.parse(data);
          this.setTypPrzychodu(item.TypArrival);
          this.setPlatnik(item.Platnik);
        })
        .fail((e) => {
          console.err(e);
          this.$message.error(this.$t("Error loading document"));
        });
    },

    sortMediaList: function () {
      let sort = {
        specjalista: this.selectGroup.ASSIGNED_BY_ID,
        year: this.selectGroup.year,
        month: Number(this.selectGroup.month),
      };

      getMediaListForecastsSort(sort)
        .done((data) => {
          this.$message.info(this.$t("Download complete!"));
          let item = data == "" ? {} : JSON.parse(data);

          let indexMediaList = -1;
          this.MediaListSource = [];
          for (let i in item.project) {
            let deal = item.project[i];
            this.MediaListSource = this.MediaListSource.concat(
              deal.info.map((el) => {
                indexMediaList++;
                return {
                  key: indexMediaList,
                  dataY: el.year,
                  dataM: el.month,
                  id: el.dealID,
                  project: el.DEAL_TITLE,
                  kontrahent: el.DEAL_COMPANY_ID,
                  typPrzychodu: el.typeArrival,
                  platnik: el.payer,
                  specjalista: el.ASSIGNED_BY_ID,
                  opiekunCS: el.responsible,
                  plan: el.plan,
                  komentarz: el.DEAL_COMMENTS,
                  performed: el.performed,
                  previousPlan: el.previousPlan,
                  editMode: false,
                };
              })
            );
          }
        })
        .fail((e) => {
          console.err(e);
          this.$message.error(this.$t("Error loading document"));
        });
    },

    getSelectUserList: function () {
      return this.settings.data_user.map((user) => ({
        id: user.ID,
        name: user.LAST_NAME + " " + user.NAME,
      }));
    },
    setTypPrzychodu(typArrival) {
      this.typPrzychoduList = typArrival.map((el) => ({
        id: el.ID,
        name: el.VALUE,
      }));
    },
    setPlatnik(platnik) {
      this.platnikList = platnik.map((el) => ({ id: el.ID, name: el.VALUE }));
    },

    searchTypeArrival: function (idTypeArrival) {
      let typeArrival = this.typPrzychoduList.find((type) => {
        return type.id == idTypeArrival;
      });
      return typeArrival ? typeArrival.name : "";
    },
    searchPlatnik: function (idPlatnik) {
      let platnik = this.platnikList.find((type) => {
        return type.id == idPlatnik;
      });
      return platnik ? platnik.name : "";
    },
    searchCompany: function (idCompany) {
      let company = this.settings.company.find((company) => {
        return company.ID == idCompany;
      });
      return company ? company.TITLE : "";
    },
    searchUser: function (idUser) {
      let user = this.settings.data_user.find((user) => {
        return user.ID == idUser;
      });
      return user ? user.LAST_NAME + " " + user.NAME : "";
    },
  },
  mounted() {
    this.userList = this.getSelectUserList();
    this.selectData = moment();
    this.updateDataMediaList();
    this.sortMediaList();
    BX24.fitWindow();
  },
};
</script>

<style scoped>
.top-menu {
  display: flex;
  justify-content: center;
}
.btn-back {
  margin: 10px;
  margin-left: auto;
}
</style>
